import { ActionBase } from '../../../core/store/action/ActionBase';
import { ExtractListModel } from "../../models/ExtractListModel";

export const SET_SELECTED_EXTRACT_LIST_MODEL = '[Extract] Set Selected Extract List Model';

export class SetSelectedExtractListModelAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = SET_SELECTED_EXTRACT_LIST_MODEL;

  constructor ( public payload: { model: ExtractListModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/SetSelectedExtractListModelAction.ts